import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

import { Kind } from './constants';

const actionFeedback = css`
  padding-left: ${cssTheme.gu3};
  padding-right: ${cssTheme.gu3};
  height: ${cssTheme.gu6};
  font-family: ${cssTheme.font.display};
  border-radius: ${cssTheme.radius.button.medium};
  display: flex;
  gap: ${cssTheme.gu2};
  align-items: center;

  svg {
    vertical-align: initial;
  }
`;

const availableWrapper = css`
  display: flex;
`;

const actionFeedbackLabel = css`
  display: none ${cssTheme.breakpoints.sm} {
    display: inline;
  }
`;

const glyph = css`
  margin-left: auto;
`;

export const kindClass: Record<Kind, string> = {
  PRIMARY: css`
    background: rgba(${cssTheme.palette.rgb.primaryContrast});
    color: ${cssTheme.palette.primary};
  `,
  PRIMARY_MUTED: css`
    background: rgba(${cssTheme.palette.rgb.primaryContrast}, 0.2);
    color: ${cssTheme.palette.primaryContrast};
  `,
  PRIMARY_DARK: css`
    background: rgba(${cssTheme.palette.rgb.primaryContrast});
    color: ${cssTheme.palette.grey02};
  `,
  SECONDARY_SUCCESS: css`
    background: rgba(${cssTheme.palette.rgb.grey12});
    color: ${cssTheme.palette.green01};
  `,
  SECONDARY: css`
    background: rgba(${cssTheme.palette.rgb.grey12});
    color: inherit;
  `,
  LIGHT: css`
    background: ${cssTheme.palette.highlightContrast};
    color: inherit;
  `,
  LIGHT_SUCCESS: css`
    background: ${cssTheme.palette.highlightContrast};
    color: ${cssTheme.palette.green01};
  `,
  DEFAULT: '',
};

type Props = {
  kind: Kind;
};

export const getClassNames = ({ kind }: Readonly<Props>) => ({
  actionFeedback: cx(actionFeedback, kindClass[kind]),
  actionFeedbackLabel,
  availableWrapper,
  glyph,
});
